<!--收件信息-->
<template>
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">收件人员管理 ></p>
            <el-input placeholder="姓名/联系方式" v-model="selectValue" size="small" class="input-with-select"
                style="width:300px">
                <el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
            </el-input>
            <div></div>
        </div>

        <!-- 第二行 表格操作栏 -->
        <div class="selectBar">
            <div style="overflow:hidden">
                <label>地址：</label>
        
                <el-select v-model="address.pname" @change="choseProvince" @clear="selectPCode = ''" clearable class="pca" placeholder="省">
                    <el-option v-for="(item,index) in address.province" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
                
                <el-select v-model="address.cname" @change="choseCity" @clear="selectCCode = ''" clearable class="pca" placeholder="市">
                    <el-option v-for="(item,index) in address.city" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
                
                <el-select v-model="address.bname" @change="choseBlock" @clear="selectACode = ''" clearable class="pca" placeholder="区">
                    <el-option v-for="(item,index) in address.area" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
        
            </div>
        </div>

        <div class="table" style="height:calc( 100% - 140px )">
            <el-table :data="list" border :header-cell-style="{background:'#fafdff',color:'#606266',fontWeight:'normal'}" height="calc( 100% - 120px )">
                <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mobile" label="联系方式" show-overflow-tooltip></el-table-column>
                <el-table-column prop="address_name" label="地址" show-overflow-tooltip></el-table-column>

                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" plain @click="editDialog(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small" plain @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>

        <!--编辑-->
        <el-dialog :visible="dialogOpen" :title="dialogTitle" :close-on-click-modal="false" width="600px" @close=" dialogOpen=false " :append-to-body="true" :destroy-on-close="true">
            <div class="editBox">
                <el-form ref="edit" :model="formData" :rules="formRules" @submit.native.prevent label-width="80px">
                    <el-form-item label="姓  名" prop="name">
                        <el-input v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式" prop="mobile">
                        <el-input v-model="formData.mobile" class="no-number" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="地  址" prop="address" style="width: 100%;"> 
                        <el-cascader ref="cascaderAddr"  v-model="formData.address" :options="citydata" :props="{ expandTrigger: 'hover' }" clearable @change="addressChange">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="detailed_address">
                        <el-input v-model="formData.detailed_address"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="editBtn">
                <el-button type="primary" size="small" @click="submit()">保存</el-button>
                <el-button size="small" @click="dialogOpen=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // import cityData from "../assets/js/city.data.js"
    export default {
        name: 'Home',
        data: function () {
            return {
                curr: 1,
                row: 10,
                count: 0,
                pages: 1, //总页数

                dialogOpen: false,
                dialogTitle: '编辑',
                citydata:[],
                formData: {},

                selectValue: '',
                selectPCode: '',
                selectCCode: '',
                selectACode: '',

                address: {
                    province: [],
                    city: [],
                    area: [],
                    pname: '',//省的名字
                    cname: '',//市的名字
                    bname: '',  //区的名字
                    shi1: [],
                    qu1: [],
                },
                
                // 表单验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入收件人姓名',
                        trigger: 'change'
                    }],
                    mobile: [{
                        required: true,
                        // pattern: /^1[0-9][0-9]\d{8}$/,
                        message: '联系方式格式不正确',
                        trigger: 'change'
                    }],
                    address: [{
                        required: true,
                        message: '请选择收件人地址',
                        trigger: 'change'
                    }],
                    detailed_address: [{
                        required: true,
                        message: '请输入详细地址',
                        trigger: 'change'
                    }],
                },
                list: []
            }
        },
        mounted: function () {
            var area = localStorage.getItem('area')
            this.citydata = JSON.parse(area)
            this.getList()
            this.init()
            
        },
        methods: {
            init: function () {
                var _this = this
                // this.citydata = cityData.cityData3
                this.citydata.forEach(function (item, index) {
                    _this.address.province.push({ id: item.value, name: item.label, children: item.children })
                    if (_this.address.pname) {
                        item.children.forEach(city => {
                            _this.address.city.push({ id: city.value, name: city.label, children: city.children })
                        })
                    }
                })
            },

            getList: function () {
                this.http.post('/recipient/getList', {
                    row: this.row,
                    curr: this.curr,
                    search: this.selectValue,
                    address: this.selectPCode && !this.selectCCode && !this.selectACode ? this.selectPCode : this.selectPCode && this.selectCCode && !this.selectACode ? this.selectCCode : this.selectACode
                }).then(res => {
                    this.list = res.list
                    this.curr = res.curr;
                    this.pages = res.pages;
                    this.count = res.count;
                })
            },
            

            choseProvince: function (e) {
                let that = this;
                that.address.city = [];   //清除市级所有数据
                that.address.area = [];	  //清除区域所有数据
                that.address.cname = '';
                that.address.bname = '';
                that.selectPCode = e
                for (var index2 in that.address.province) {
                    if (e === that.address.province[index2].id) {
                        that.address.shi1 = that.address.province[index2].children
                        that.address.pname = that.address.province[index2].name
                        that.address.shi1.forEach(function (citem, cindex) {
                            that.address.city.push({ id: citem.value, name: citem.label, children: citem.children })
                        })
                    }
                }
                this.curr = 1
                this.getList()
            },

            //选市
            choseCity: function (e) {
                let that = this;
                that.address.area = [];
                that.address.bname = ''
                that.selectCCode = e
                if (that.address.pname == '') {
                    that.address.province = [];
                }
                for (var index3 in that.address.city) {
                    if (e === that.address.city[index3].id) {
                        that.address.qu1 = that.address.city[index3].children
                        that.address.cname = that.address.city[index3].name
                        that.address.qu1.forEach(function (bitem, bindex) {
                            that.address.area.push({ id: bitem.value, name: bitem.label, children: [] })
                        })
                    }
                }
                this.curr = 1
                this.getList()
            },
            // 选区
            choseBlock: function (e) {
                let that = this;
                that.selectACode = e
                for (var index4 in that.address.area) {
                    if (e === that.address.area[index4].id) {
                        that.address.bname = that.address.area[index4].name
                    }
                }
                this.curr = 1
                this.getList()
            },
            //编辑语录
            editDialog(data) {
                this.dialogOpen = true
                var form = JSON.stringify(data)
                this.formData = JSON.parse(form)
            },
            addressChange(value) {
                this.formData.address_name = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels.join(',')
                this.formData.address = value;
            },
            //删除收件人
            del:function(id){
                this.$confirm('确定要删除吗?', '提示').then(() => {
                    this.http.post('/recipient/delete', {
                        id: id
                    }).then(res => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                }).catch(() => {
                    this.$message.info('已取消删除')
                });
            },
            //提交
            submit: function () {
                this.$refs['edit'].validate((valid) => {
                    if (valid) {
                        this.http.post('/recipient/edit',{
                            id: this.formData.id ? this.formData.id : '',
                            user_id: this.formData.user_id,
                            name: this.formData.name,
                            mobile: this.formData.mobile,
                            address: this.formData.address,
                            detailed_address: this.formData.detailed_address,
                            address_name: this.formData.address_name
                        }).then(res => {
                            this.dialogOpen = false
                            this.getList()
                        })
                    }
                })
            },
            currChange: function (curr) {
                this.curr = curr;
                this.getList()
            },
            sizeChange: function (row) {
                this.row = row;
                this.getList()
            },
        }
    }
</script>